import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

import { Col, Row, Table, Tab, Tabs, Spinner } from 'react-bootstrap';

import GET_FACTSHEET from "../../../graphql/queries/IIAs/getFactsheet";
import GET_HEI from "../../../graphql/queries/IIAs/getHei";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useBreakpoint from "../../../hooks/useBreakpoint";
import ExportFactsheetPdf from "../Listing/ExportFactsheetPdf";



const PartnerFactSheetSingleView = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'factsheetBrowser.singleView' });
    
    const months = [
        t("months.jan"),
        t("months.feb"),
        t("months.mar"),
        t("months.apr"),
        t("months.may"),
        t("months.jun"),
        t("months.jul"),
        t("months.aug"),
        t("months.sep"),
        t("months.oct"),
        t("months.nov"),
        t("months.dec")
    ]
    const [ size ] = useBreakpoint();
    const { heiID } = useParams();
    const [ hasData, setHasData ] = useState(false);

    const [partnerData, setPartnerData] = useState({});

    const [calendarNomAutumnPartner, setCalendarNomAutumnPartner] = useState("");
    const [calendarNomSpringPartner, setCalendarNomSpringPartner] = useState("");
    const [calendarAppSpringPartner, setCalendarAppSpringPartner] = useState("");
    const [calendarAppAutumnPartner, setCalendarAppAutumnPartner] = useState("");
    const [applicationInfoEmailPartner, setApplicationInfoEmailPartner] = useState("");
    const [applicationInfoPhonePartner, setApplicationInfoPhonePartner] = useState("");
    const [applicationInfoWebsitePartner, setApplicationInfoWebsitePartner] = useState([]);
    const [additionalRequirementsPartner, setAdditionalRequirementsPartner] = useState([]);
    const [additionalInfosPartner, setAdditionalInfosPartner] = useState([]);
    const [accessibilitiesPartner, setAccessibilitiesPartner] = useState([]);
    const [housingInfoPartner, setHousingInfoPartner] = useState({});
    const [visaInfoPartner, setVisaInfoPartner] = useState({});
    const [insuranceInfoPartner, setInsuranceInfoPartner] = useState({});

    const { loading: loadingPartnerData, data: dataPartner } = useQuery(GET_HEI,
        { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: { heiID: heiID }}
    )

    const { loading: loadingHeiFactsheetPartner } =
        useQuery(
            GET_FACTSHEET, { notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: {
                heiID: heiID
              },
                onCompleted: (data) =>  {
                    data?.factsheet ? setHasData(true) : setHasData(false);
                    setCalendarNomAutumnPartner(data?.factsheet?.calendar?.student_nom_autumn_term);
                    setCalendarNomSpringPartner(data.factsheet?.calendar?.student_nom_spring_term);
                    setCalendarAppAutumnPartner(data?.factsheet?.calendar?.student_app_autumn_term);
                    setCalendarAppSpringPartner(data.factsheet?.calendar?.student_app_spring_term);
                    setAdditionalRequirementsPartner(data.factsheet?.additional_requirements);
                    setAccessibilitiesPartner(data?.factsheet?.accessibilities);
                    setHousingInfoPartner(data?.factsheet?.housing_info);
                    setVisaInfoPartner(data?.factsheet?.visa_info);
                    setInsuranceInfoPartner(data?.factsheet?.insurance_info);
                    setApplicationInfoEmailPartner(data?.factsheet?.application_info?.email);
                    setApplicationInfoPhonePartner(data.factsheet?.application_info?.phone_number?.e164);
                    setApplicationInfoWebsitePartner(data?.factsheet?.application_info?.website_urls);
                    setAdditionalInfosPartner(data?.factsheet?.additional_infos);
                
                }
            }
        );

    useEffect(() => {
        if (dataPartner) {
            setPartnerData(dataPartner?.hei);
        }
    }, [dataPartner]);

    const formatDate = (string) => {
        if (!string) return "";
        const [day, month] = string.replace("--", "").split("-");
        const displayDay = parseInt(day);
        const displayMonth = months[parseInt(month) - 1];
        return displayDay && displayMonth ? `${displayDay} ${displayMonth}` : ""
    }

    if (loadingHeiFactsheetPartner || loadingPartnerData) {
        return (
        <div
            style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)"
            }}
        >
            <Spinner
                as="div"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                className="align-middle my-auto"
            />
            <span>{t('loadingMessage')}</span>
        </div>
    )
    }


    return (
        hasData ? 
        (size !== "md" && size !== "sm" && size !== "xs") ? (
            <>
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 75}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('partnerInfo.title')} style={{background: "#ffff"}}>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "20%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>HEI ID</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerInfo.name')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerInfo.erasmusCode')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('partnerInfo.country')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'></th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "20%", paddingTop: 0, paddingBottom: 15, paddingLeft: 24}} className='border-hidden body'>{heiID}</td>
                            <td style={{width: "25%", paddingTop: 0, paddingBottom: 15}} className='border-hidden  body'>{partnerData?.name}</td>
                            <td style={{paddingTop: 0, paddingBottom: 15}} className='border-hidden  body'>{partnerData?.erasmusCode}</td>
                            <td style={{paddingTop: 0, paddingBottom: 15}} className='border-hidden  body'>{partnerData?.country}</td>
                            <td style={{paddingTop: 0, paddingBottom: 15}} className='border-hidden  body'><ExportFactsheetPdf heiId={heiID} /></td>
                            </tr>
                        </tbody>
                        </Table>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('calendar.title')} style={{background: "#ffff"}}>
                    <div style={{paddingTop: 20, paddingLeft: 24}} className='h6-style'>{t('calendar.applicationsForNominated')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('calendar.autumnTerm')}</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('calendar.springTerm')}</th>
                            <th style={{width: "50%"}} className='border-hidden  body'></th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 5, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{formatDate(calendarAppAutumnPartner)}</td>
                            <td style={{width: "25%", paddingTop: 5, paddingBottom: 20, paddingLeft: 24}} className='border-hidden  body'>{formatDate(calendarAppSpringPartner)}</td>
                            <th style={{width: "50%"}} className='border-hidden  body'></th>
                            </tr>
                        </tbody>
                    </Table>
                    <div style={{paddingLeft: 24}} className='h6-style'>{t('calendar.studentNominations')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('calendar.autumnTerm')}</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('calendar.springTerm')}</th>
                            <th style={{width: "50%"}} className='border-hidden  body'></th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 5, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{formatDate(calendarNomAutumnPartner)}</td>
                            <td style={{width: "25%", paddingTop: 5, paddingBottom: 20, paddingLeft: 24}} className='border-hidden  body'>{formatDate(calendarNomSpringPartner)}</td>
                            <th style={{width: "50%"}} className='border-hidden  body'></th>
                            </tr>
                        </tbody>
                    </Table>
                    <div style={{paddingLeft: 24}} className='h6-style'>{t('calendar.applicationProcedure')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>EMAIL</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('calendar.phone')}</th>
                            <th style={{width: "50%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>WEBSITE</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{applicationInfoEmailPartner}</td>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden  body'>{applicationInfoPhonePartner}</td>
                            <td style={{width: "50%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden  body'><strong>{applicationInfoWebsitePartner?.length > 0 && applicationInfoWebsitePartner}</strong></td>
                            </tr>
                        </tbody>
                        </Table>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('additionalRequirements.title')} style={{background: "#ffff"}}>
                    <Table border={1} frame="void" rules="rows">
                        <thead className='thead-font'>
                            <tr>
                            <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('additionalRequirements.requirements')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('additionalRequirements.details')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('additionalRequirements.ectsNumber')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('additionalRequirements.subjectFieldISCED')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('additionalRequirements.studyLevelEQF')}</th>
                            <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('additionalRequirements.website')}</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            {additionalRequirementsPartner?.map((elem, index) => (
                                <tr>
                                <td style={{paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{elem?.name}</td>
                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.details}</td>
                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.ects}</td>
                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.isced_f_code + elem?.isced_f_code_name}</td>
                                <td style={{paddingBottom: 20}} className='border-hidden body'>{elem?.eqf_level}</td>
                                <td style={{paddingBottom: 20}} className='border-hidden body'><a href={elem?.information_websites} target="_blank" style={{textDecoration: "none"}}>{elem?.information_websites}</a></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 24, paddingBottom: 12}}>{t('additionalRequirements.message')}</div>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>

            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('inclusionAndAccessibility.title')} style={{background: "#ffff"}}>
                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('inclusionAndAccessibility.descriptionMain.part1')}<br/>{t('inclusionAndAccessibility.descriptionMain.part2')}</div>
                        <div className='h6-style' style={{marginTop: 22, paddingLeft: 20}}>{t('inclusionAndAccessibility.infrastructure')} </div>
                        <Table responsive>
                            <thead className='thead-font'>
                                <tr>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('inclusionAndAccessibility.name')}</th>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('inclusionAndAccessibility.description')}</th>
                                <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('inclusionAndAccessibility.contact')}</th>
                                </tr>
                            </thead>
                            <tbody className='tbody-font'>
                                {accessibilitiesPartner?.map((elem, index) => (
                                    elem?.type?.startsWith("infrastructure") && <tr>
                                    <td style={{width: "25%", paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{elem?.name}</td>
                                    <td style={{width: "25%", paddingBottom: 20}} className='border-hidden body'>{elem?.description}</td>
                                    <td style={{width: "50%", paddingBottom: 20}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                    + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                        + elem?.info?.website_urls : ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className='h6-style' style={{marginTop: 22, paddingLeft: 20}}>{t('inclusionAndAccessibility.services')}</div>
                        <Table responsive>
                            <thead className='thead-font'>
                                <tr>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('inclusionAndAccessibility.name')}</th>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('inclusionAndAccessibility.description')}</th>
                                <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('inclusionAndAccessibility.contact')}</th>
                                </tr>
                            </thead>
                            <tbody className='tbody-font'>
                                {accessibilitiesPartner?.map((elem, index) => (
                                    elem?.type?.startsWith("service") && <tr>
                                    <td style={{width: "25%", paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{elem?.name}</td>
                                    <td style={{width: "25%", paddingBottom: 20}} className='border-hidden body'>{elem?.description}</td>
                                    <td style={{width: "50%", paddingBottom: 20}} className='border-hidden body'>{elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                    + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                        + elem?.info?.website_urls : ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table></Tab>
                    </Tabs>
                </Col>
            </Row>                  
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('housing.title')} style={{background: "#ffff"}}>
                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('housing.description.part1')}<br/>{t('housing.description.part2')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>EMAIL</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('calendar.phone')}</th>
                            <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>WEBSITE</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{housingInfoPartner?.email}</td>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{housingInfoPartner?.phone_number?.e164 ? ", " + housingInfoPartner?.phone_number?.e164 : ""}</td>
                            <td style={{width: "50%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{housingInfoPartner?.website_urls ? ", " + housingInfoPartner?.website_urls : ""}</td>
                            </tr>
                        </tbody>
                        </Table>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('visa.title')} style={{background: "#ffff"}}>
                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('visa.description.part1')}<br/>{t('visa.description.part2')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>EMAIL</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('calendar.phone')}</th>
                            <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>WEBSITE</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{visaInfoPartner?.email}</td>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{visaInfoPartner?.phone_number?.e164 ? ", " + visaInfoPartner?.phone_number?.e164 : ""}</td>
                            <td style={{width: "50%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{visaInfoPartner?.website_urls ? ", " + visaInfoPartner?.website_urls : ""}</td>
                            </tr>
                        </tbody>
                        </Table>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('insurance.title')} style={{background: "#ffff"}}>
                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('insurance.description.part1')}<br/>{t('insurance.description.part2')}<br/>{t('insurance.description.part3')}</div>
                    <Table responsive>
                        <thead className='thead-font'>
                            <tr>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>EMAIL</th>
                            <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('calendar.phone')}</th>
                            <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>WEBSITE</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-font'>
                            <tr>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{insuranceInfoPartner?.email}</td>
                            <td style={{width: "25%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{insuranceInfoPartner?.phone_number?.e164 ? ", " + insuranceInfoPartner?.phone_number?.e164 : ""}</td>
                            <td style={{width: "50%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{insuranceInfoPartner?.website_urls ? ", " + insuranceInfoPartner?.website_urls : ""}</td>
                            </tr>
                        </tbody>
                        </Table>
                    </Tab>
                    </Tabs>
                </Col>
            </Row>

            <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
                <Col style={{marginTop: 50}}>
                    <Tabs id="application-info">
                <Tab eventKey="home" title={t('additionalInfo.title')} style={{background: "#ffff"}}>
                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 12}}>{t('additionalInfo.description.part1')}<br/>{t('additionalInfo.description.part2')}</div>
                    
                    {additionalInfosPartner?.map((elem, index) => (
                        <>
                        <div className='h6-style' style={{marginTop: 22, paddingLeft: 12}}>{elem?.type} </div>
                        <Table responsive>
                            <thead className='thead-font'>
                                <tr>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>EMAIL</th>
                                <th style={{width: "25%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('calendar.phone')}</th>
                                <th style={{width: "50%", paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>WEBSITE</th>
                                </tr>
                            </thead>
                            <tbody className='tbody-font'>
                                <tr>
                                <td style={{width: "25%", paddingTop: 4, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{elem?.info?.email}</td>
                                <td style={{width: "25%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{elem?.info?.phone_number?.e164 ? ", " 
                                    + elem?.info?.phone_number?.e164 : ""}</td>
                                <td style={{width: "50%", paddingTop: 4, paddingBottom: 20}} className='border-hidden  body'>{elem?.info?.website_urls?.length > 0 ? ", " 
                                        + elem?.info?.website_urls : ""}</td>
                                </tr>
                            </tbody>
                        </Table>
                        </>
                    ))}
                    </Tab>
                    </Tabs>
                </Col>
            </Row>

        <Row><div style={{marginLeft: 50, marginTop: 20, marginBottom: 20}} className='body'>
            {t('message.part1')}<br/>
            {t('message.part2')}<br/>
            {t('message.part3')}</div>
        </Row> 
        </>
        ) : (
            <>
                <Row style={{marginLeft: 2, marginRight: 5}}>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="PARTNER INFO" style={{background: "#ffff"}}>
                                <Row style={{marginLeft: 25,marginRight: 25}}>
                                    <Col xs={6} sm={6} style={{marginTop: 17}} className='thead-font label-style'>HEI ID</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 17}} className='tbody-font body'>{heiID}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>NAME:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{partnerData?.name}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>ERASMUS CODE:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{partnerData?.erasmusCode}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>COUNTRY:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{partnerData?.country}</Col>
                                    <Col xs={12} sm={12} style={{marginTop: 6,marginBottom: 15}} className='tbody-font body text-end'><ExportFactsheetPdf heiId={heiID} /></Col>
                                </Row>
                            </Tab>
                            </Tabs>
                        </Col>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="CALENDAR" style={{background: "#ffff"}}>
                                    <div style={{paddingLeft: 24, paddingTop: 15, paddingBottom: 20}}>
                                    <div className='h6-style'>Deadline for applications of incoming students: </div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={1} className="thead-font label-style">Autumn Term: </Col>
                                        <Col lg={11} className='body'>{formatDate(calendarAppAutumnPartner)}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={1} className="thead-font label-style">Spring Term: </Col>
                                        <Col lg={11} className='body'>{formatDate(calendarAppSpringPartner)}</Col>
                                    </Row>
                                    <div className='h6-style' style={{marginTop: 22}}>Deadline for Nominations: </div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={1} className="thead-font label-style">Autumn Term: </Col>
                                        <Col lg={11} className='body'>{formatDate(calendarNomAutumnPartner)}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={1} className="thead-font label-style">Spring Term: </Col>
                                        <Col lg={11} className='body'>{formatDate(calendarNomSpringPartner)}</Col>
                                    </Row>
                                    <div className='h6-style' style={{marginTop: 22}}>Application procedure for Nominated Students: </div>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2} className="thead-font label-style">Contact Email: </Col>
                                        <Col lg={10} className='body'>{applicationInfoEmailPartner}</Col>
                                    </Row>
                                    
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2} className="thead-font label-style">Contact Phone: </Col>
                                        <Col lg={10} className='body'>{applicationInfoPhonePartner}</Col>
                                    </Row>
                                    <Row style={{marginTop: 12}}>
                                        <Col lg={2} className="thead-font label-style">Website for information: </Col>
                                        <Col lg={10} className='body'>{applicationInfoWebsitePartner?.length > 0 && applicationInfoWebsitePartner}</Col>
                                    </Row>
                                    </div>
                        </Tab>
                            </Tabs>
                        </Col>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="ADDITIONAL REQUIREMENTS" style={{background: "#ffff"}}>
                                <div style={{paddingLeft: 12, paddingTop: 15, paddingBottom: 20}}>
                                {additionalRequirementsPartner?.map((elem, index) => (
                                    <div class="p-3  justify-content-around align-items-center">
                                    
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"REQUIREMENT:"}
                                        </div>
                                        <div className="col body">
                                            {elem?.name}
                                        </div>
                                    </div>
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"DETAILS:"}
                                        </div>
                                        <div className="col body">
                                            {elem?.details}
                                        </div>
                                    </div>
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"ECTS NUMBER:"}
                                        </div>
                                        <div className="col body">
                                            {elem?.ects}
                                        </div>
                                    </div>
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"SUBJECT FIELD (ISCED):"}
                                        </div>
                                        <div className="col body">
                                            {elem?.isced_f_code + elem?.isced_f_code_name}
                                        </div>
                                    </div>
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"STUDY LEVEL (EQF):"}
                                        </div>
                                        <div className="col body">
                                            {elem?.eqf_level}
                                        </div>
                                    </div>
                                    <div className="row thead-font label-style">
                                        <div className="col table-header">
                                            {"WEBSITE:"}
                                        </div>
                                        <div className="col body">
                                        <a href={elem?.information_websites} target="_blank" style={{textDecoration: "none"}}>{elem?.information_websites}</a>
                                        </div>
                                    </div>
                                    </div>
                                ))}
                                <div className='body' style={{marginTop: 15, fontStyle: "italic", paddingLeft: 12, paddingRight: 12}}>The institution will send its decision within 4 weeks, and no later than 5 weeks.</div>
                                </div>
                        </Tab>
                            </Tabs>
                        </Col>
                        <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="INCLUSION AND ACCESSIBILITY" style={{background: "#ffff"}}>
                                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 24, paddingRight: 24}}>The institution will provide support to incoming mobile participants with special needs, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                    <div className='h6-style' style={{marginTop: 22, paddingLeft: 24}}>Infrastructure </div>
                                    {accessibilitiesPartner?.map((elem, index) => (
                                        elem?.type === "infrastructure" && <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"NAME:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.name}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"DESCRIPTION:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.description}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"CONTACT:"}
                                            </div>
                                            <div className="col body">
                                            {elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                + elem?.info?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                                    ))}
                                    
                                    
                                    <div className='h6-style' style={{marginTop: 22, paddingLeft: 24}}>Services</div>
                                    {accessibilitiesPartner?.map((elem, index) => (
                                        elem?.type === "service" && <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"NAME:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.name}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"DESCRIPTION:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.description}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"CONTACT:"}
                                            </div>
                                            <div className="col body">
                                            {elem?.info?.email}{elem?.info?.phone_number?.e164 ? ", " 
                                                + elem?.info?.phone_number?.e164 : ""}{elem?.info?.website_urls ? ", " 
                                                + elem?.info?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                                    ))}
                               </Tab>
                               </Tabs>
                               </Col>
                    
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="HOUSING" style={{background: "#ffff"}}>
                                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 24, paddingRight: 24}}>The institution will guide incoming mobile participants in finding accommodation, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 24}}>Contact </div>
                                    <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"EMAIL:"}
                                            </div>
                                            <div className="col body">
                                                {housingInfoPartner?.email}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"PHONE:"}
                                            </div>
                                            <div className="col body">
                                                {housingInfoPartner?.phone_number?.e164 ? ", " + housingInfoPartner?.phone_number?.e164 : ""}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"WEBSITE:"}
                                            </div>
                                            <div className="col body">
                                                {housingInfoPartner?.website_urls ? ", " + housingInfoPartner?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                        </Tab>
                        </Tabs>
                    </Col>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="VISA" style={{background: "#ffff"}}>
                                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 24, paddingRight: 24}}>The institution will provide assistance, when required, in securing visas for incoming and outbound mobile participants, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 24}}>Contact </div>
                                     <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"EMAIL:"}
                                            </div>
                                            <div className="col body">
                                                {visaInfoPartner?.email}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"PHONE:"}
                                            </div>
                                            <div className="col body">
                                                {visaInfoPartner?.phone_number?.e164 ? ", " + visaInfoPartner?.phone_number?.e164 : ""}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"WEBSITE:"}
                                            </div>
                                            <div className="col body">
                                                {visaInfoPartner?.website_urls ? ", " + visaInfoPartner?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                        </Tab>
                        </Tabs>
                    </Col>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="INSURANCE" style={{background: "#ffff"}}>
                                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 24, paddingRight: 24}}>The institution will provide assistance in obtaining insurance for incoming and outbound mobile participants, according to the requirements of the Erasmus Charter for Higher Education.<br/> The receiving institution will inform mobile participants of cases in which insurance cover is not automatically provided.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                    <div className='h6-style' style={{marginTop: 10, paddingLeft: 24}}>Contact </div>
                                    <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"EMAIL:"}
                                            </div>
                                            <div className="col body">
                                                {insuranceInfoPartner?.email}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"PHONE:"}
                                            </div>
                                            <div className="col body">
                                                {insuranceInfoPartner?.phone_number?.e164 ? ", " + insuranceInfoPartner?.phone_number?.e164 : ""}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"WEBSITE:"}
                                            </div>
                                            <div className="col body">
                                                {insuranceInfoPartner?.website_urls ? ", " + insuranceInfoPartner?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                        </Tab>
                        </Tabs>
                    </Col>
                    <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
                            <Tabs
                            id="application-info"
                            >
                            <Tab eventKey="home" title="ADDITIONAL INFORMATION" style={{background: "#ffff"}}>
                                    <div className='body' style={{paddingTop: 15, fontStyle: "italic", paddingLeft: 24, paddingRight: 24}}>The institution will provide support to incoming mobile participants with special needs, according to the requirements of the Erasmus Charter for Higher Education.<br/> Information and assistance can be provided by the following contact points and information sources:</div>
                                    {additionalInfosPartner?.map((elem, index) => (
                                        <>
                                        <div className='h6-style' style={{marginTop: 22, paddingLeft: 24}}>{elem?.type} </div>
                                        <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>CONTACT</th>
                                        <div class="p-3  justify-content-around align-items-center">
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"EMAIL:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.info?.email}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"PHONE:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.info?.phone_number?.e164 ? ", " + elem?.info?.phone_number?.e164 : ""}
                                            </div>
                                        </div>
                                        <div className="row thead-font label-style" style={{paddingLeft: 12}}>
                                            <div className="col table-header">
                                                {"WEBSITE:"}
                                            </div>
                                            <div className="col body">
                                                {elem?.info?.website_urls ? ", " + elem?.info?.website_urls : ""}
                                            </div>
                                        </div>
                                        </div>
                                        </>
                                    ))}
                               </Tab>
                            </Tabs>
                    </Col>
                        <Row><div style={{paddingLeft: 30, paddingRight: 15, marginTop: 20, marginBottom: 20}} className='body'>A Transcript of Records will be issued by the institution no later than 6 weeks after the assessment period has finished.<br/>
    [It should normally not exceed five weeks according to the Erasmus Charterfor Higher Education guidelines]<br/>
    *After creating the profile of the higher education institution and adding the relevant general information, the higher education institution can proceed to generate Inter-Institutional Agreements with their selected partners.</div></Row>
                </Row>
        </>)
    :
        <div className="text-center text-danger mx-auto">{t('errorMessage')}</div>
    )
}

export default PartnerFactSheetSingleView;